// ** Router Import
import axios from "axios";
// import ReactGA from "react-ga";
import { hot } from "react-hot-loader/root";
import history from "./history";
import Router from "./router/Router";
// ReactGA.initialize("UA-51392528-7");

const baseUrl = process.env.NODE_ENV === "development" ? "http://localhost:8080" : "";
axios.defaults.baseURL = baseUrl;

const App = (props) => {
  return <Router history={history} />;
};

export default process.env.NODE_ENV === "development" ? hot(App) : App;
